<template>
	<b-form @submit.prevent>
		<b-row class="mt-3">
			<b-col>
				<b-link class="float-right ml-3" @click.prevent="deleteClock" title="Delete this clock">
					<b-icon font-scale="1.5" icon="trash" variant="danger"></b-icon>
				</b-link>

				<save-or-edit-buttons :editable="editable.name" section="name" @save="saveSection" @edit="editSection"></save-or-edit-buttons>
			</b-col>
		</b-row>

		<b-row class="mt-3" v-if="editable.name" @change="someThingChanged">
			<b-col>
				<b-form-group breakpoint="md" horizontal>
					<b-form-input id="name" size="lg" placeholder="Clock Name" v-model="clock.Name" maxlength="60" required />
				</b-form-group>
			</b-col>

			<b-col>
				{{ customerName ? customerName : 'Select Customer' }}
				<b-link
					v-b-modal.sharedModal
					@click.prevent="
						modalContent = 'customer';
						modalTitle = 'Select Customer';
					"
				>
					<b-icon font-scale="1.5" icon="pencil-square"></b-icon>
				</b-link>
			</b-col>
		</b-row>

		<b-row class="mt-3" v-else>
			<b-col cols="12">
				<b-row>
					<b-col>
						<h1>{{ clock.Name }}</h1>
					</b-col>
				</b-row>

				<b-row>
					<b-col>
						<b-link
							:to="{
								name: 'customerupdate',
								params: { id: clock.CustomerId }
							}"
							>{{ customerName }}</b-link
						>
					</b-col>
				</b-row>
			</b-col>
		</b-row>

		<b-row class="mt-3">
			<b-col>
				<b-table-simple striped bordered>
					<b-tbody>
						<tr v-for="(contract, index) in clock.ServiceContracts" :key="index + 10">
							<td class="align-middle">
								Service Contract:
								<b-link
									:to="{
										name: 'contractupdate',
										params: { id: contract.Id }
									}"
									>{{ contract.Reference }}</b-link
								>
							</td>
							<td class="align-middle">Every {{ contract.Frequency }} Months</td>
							<td class="align-middle">
								Next Service:
								{{ formatDate(contract.FirstService) }}
							</td>
						</tr>
					</b-tbody>
				</b-table-simple>
			</b-col>
		</b-row>

		<b-row class="mb-3">
			<b-col>
				<b-button
					v-b-modal.sharedModal
					title="Add a Job"
					@click.prevent="
						modalContent = 'job';
						modalTitle = 'New Job';
					"
					variant="outline-danger"
					>New Enquiry</b-button
				>
			</b-col>
		</b-row>

		<b-tabs content-class="mt-3">
			<b-tab title="Location" active>
				<b-row class="mt-3">
					<b-col>
						<h3>Address</h3>
					</b-col>

					<b-col>
						<save-or-edit-buttons :editable="editable.address" section="address" @save="saveSection" @edit="editSection"></save-or-edit-buttons>
					</b-col>
				</b-row>

				<b-row class="mt-3">
					<b-col v-if="editable.address" @change="someThingChanged">
						<b-form-group breakpoint="md" horizontal>
							<b-form-input id="address1" placeholder="Address line 1" v-model="clock.Address.Address1" type="text" required />
						</b-form-group>

						<b-form-group breakpoint="md" horizontal>
							<b-form-input id="address2" placeholder="Address line 2" v-model="clock.Address.Address2" type="text" />
						</b-form-group>

						<b-form-group breakpoint="md" horizontal for="town">
							<b-form-input id="town" placeholder="Town/City" v-model="clock.Address.Town" type="text" required />
						</b-form-group>

						<b-form-group breakpoint="md" horizontal for="county">
							<b-input id="county" placeholder="County" v-model="clock.Address.County" type="text" />
						</b-form-group>

						<b-form-group breakpoint="md" horizontal for="postcode">
							<b-form-input id="postcode" placeholder="Postcode" v-model="clock.Address.Postcode" type="text" required />
						</b-form-group>

						<b-form-group breakpoint="md" horizontal for="postcode" label="What3Words">
							<b-form-input id="what3words" placeholder="What3Words" v-model="clock.Address.What3Words" type="text" />
						</b-form-group>

						<b-row class="mt-3">
							<b-col>
								<b-form-group breakpoint="md" horizontal for="latitude" label="Latitude">
									<b-form-input id="latitude" placeholder="Latitude" v-model="clock.Address.Latitude" type="text" required />
								</b-form-group>
							</b-col>

							<b-col>
								<b-form-group breakpoint="md" horizontal for="longitude" label="Longitude">
									<b-form-input id="longitude" placeholder="Longitude" v-model="clock.Address.Longitude" type="text" required />
								</b-form-group>
							</b-col>
						</b-row>
					</b-col>

					<b-col v-else>
						<p v-html="withBr(clock.Address.Address1) + withBr(clock.Address.Address2) + withBr(clock.Address.Town) + withBr(clock.Address.County) + withBr(clock.Address.Postcode)"></p>

						<h5>What3Words</h5>

						<p>
							<b-link :href="threeWordsLink">{{ clock.Address.What3Words }}</b-link>
						</p>

						<h5>Latitude / Longitude</h5>
						<p>
							{{ clock.Address.Latitude }}
							{{ clock.Address.Longitude }}
						</p>
					</b-col>

					<b-col cols="8">
						<div id="map" class="shortmap"></div>
					</b-col>
				</b-row>

				<b-row class="mt-3">
					<b-col>
						<h3>Attending</h3>
					</b-col>

					<b-col>
						<save-or-edit-buttons :editable="editable.notes" section="notes" @save="saveSection" @edit="editSection"></save-or-edit-buttons>
					</b-col>
				</b-row>

				<b-row class="mt-3" v-if="editable.notes" @change="someThingChanged">
					<b-col cols="12">
						<b-card-group deck class="mb-3">
							<b-card bg-variant="light" title="Access Notes">
								<b-form-textarea id="accessnotes" v-model="clock.AccessNotes" />
							</b-card>

							<b-card bg-variant="light" title="Health &amp; Safety">
								<b-form-textarea id="healthsafety" v-model="clock.HealthSafety" />
							</b-card>
						</b-card-group>
					</b-col>

					<b-col cols="12">
						<b-card-group deck class="mb-3">
							<b-card bg-variant="light" title="Equipment Required">
								<b-form-textarea id="equipmentrequired" v-model="clock.EquipmentRequired" />
							</b-card>

							<b-card bg-variant="light" title="Installation Notes">
								<b-form-textarea id="installationnotes" v-model="clock.InstallationNotes" />
							</b-card>
						</b-card-group>
					</b-col>
				</b-row>

				<b-row class="mt-3" v-else>
					<b-col cols="12">
						<b-card-group deck class="mb-3">
							<b-card bg-variant="light" title="Access Notes">
								<b-card-text class="d-flex justify-content-start">
									<p>{{ clock.AccessNotes }}</p>
								</b-card-text>
							</b-card>

							<b-card bg-variant="light" title="Health &amp; Safety">
								<b-card-text class="d-flex justify-content-start">
									{{ clock.HealthSafety }}
								</b-card-text>
							</b-card>
						</b-card-group>
					</b-col>
					<b-col cols="12">
						<b-card-group deck class="mb-3">
							<b-card bg-variant="light" title="Equipment Required">
								<b-card-text class="d-flex justify-content-start">
									{{ clock.EquipmentRequired }}
								</b-card-text>
							</b-card>

							<b-card bg-variant="light" title="Installation Notes">
								<b-card-text class="d-flex justify-content-start">
									{{ clock.InstallationNotes }}
								</b-card-text>
							</b-card>
						</b-card-group>
					</b-col>
				</b-row>
			</b-tab>

			<b-tab title="Specification">
				<b-row class="mt-3">
					<b-col>
						<h3>Details</h3>
					</b-col>

					<b-col>
						<save-or-edit-buttons :editable="editable.details" section="details" @save="saveSection" @edit="editSection"></save-or-edit-buttons>
					</b-col>
				</b-row>

				<b-row class="mt-3" v-if="editable.details" @change="someThingChanged">
					<b-col cols="6">
						<b-form-group breakpoint="md" horizontal label="Manufacturer" for="manufacturer">
							<b-input id="manufacturer" v-model="clock.Manufacturer" type="text" />
						</b-form-group>
					</b-col>

					<b-col cols="4">
						<b-form-group breakpoint="md" horizontal label="Manufacture Date" for="manufactureDate">
							<b-input id="manufactureDate" v-model="clock.ManufactureDate" type="text" />
						</b-form-group>
					</b-col>

					<b-col cols="6">
						<b-form-group label="Type" for="type">
							<b-form-select v-model="clock.ClockTypeId" value-field="Id" text-field="Name" :options="clockTypes"></b-form-select>
						</b-form-group>
					</b-col>

					<b-col cols="2">
						<b-form-group label="Hour strike">
							<b-form-checkbox id="hourstrike" v-model="clock.HourStrike" switch value="true" unchecked-value="false" size="lg"> </b-form-checkbox>
						</b-form-group>
					</b-col>

					<b-col cols="4">
						<b-form-group label="Quarter chime" for="quarter-chime">
							<b-form-select id="quarter-chime" v-model="clock.QuarterChime" value-field="Value" text-field="DisplayName" :options="quarterChimes"></b-form-select>
						</b-form-group>
					</b-col>

					<b-col cols="6" offset="6" v-if="clock.QuarterChime == '4'">
						<b-form-group label="Quarter Chime Description" for="quarter-chime-other">
							<b-form-textarea id="quarter-chime-other" placeholder="Please describe quarter chime" v-model="clock.QuarterChimeOther"></b-form-textarea>
						</b-form-group>
					</b-col>

					<b-col cols="2">
						<b-form-group label="Carillon">
							<b-form-checkbox id="carillon" v-model="clock.Carillon" switch value="true" unchecked-value="false" size="lg"> </b-form-checkbox>
						</b-form-group>
					</b-col>

					<b-col cols="4" v-if="clock.Carillon">
						<b-form-group label="Manufacturer" label-for="carillonManufacturer">
							<b-input id="carillonManufacturer" v-model="clock.CarillonManufacturer" type="text" />
						</b-form-group>
					</b-col>

					<b-col cols="3" v-if="clock.Carillon">
						<b-form-group label="Date" label-for="carillonDate">
							<b-input id="carillonDate" v-model="clock.CarillonDate" type="text" />
						</b-form-group>
					</b-col>

					<b-col cols="3" v-if="clock.Carillon">
						<b-form-group label="Hammers" label-for="carillonHammers">
							<b-input id="carillonHammers" v-model="clock.CarillonHammers" type="number" min="0" />
						</b-form-group>
					</b-col>
				</b-row>

				<b-row class="mt-3" v-else>
					<b-col>
						<b-row>
							<b-col cols="12"
								>{{ fallback(clock.Manufacturer, 'No manufacturer') }}
								-
								{{ fallback(clock.ManufactureDate, 'No manufacture date') }}</b-col
							>

							<b-col cols="12">{{ fallback(clockTypeName, 'No clock type') }}</b-col>

							<b-col cols="12"><span v-if="clock.HourStrike"> Hour Strike &amp; </span>{{ quarterChimeName }} quarter chimes</b-col>

							<b-col cols="12" v-if="clock.Carillon">{{ clock.CarillonManufacturer }} Carillon - {{ clock.CarillonDate }} - {{ clock.CarillonHammers }} Hammers</b-col>
						</b-row>
					</b-col>
				</b-row>

				<b-form-fieldset>
					<b-row class="mt-3">
						<b-col cols="10">
							<h4>Equipment fitted</h4>
						</b-col>
						<b-col cols="2">
							<b-link
								class="float-right"
								v-b-modal.sharedModal
								title="Add a component"
								@click.prevent="
									modalContent = 'component';
									modalTitle = 'Select Component';
								"
							>
								<b-icon font-scale="1.5" icon="plus-square"></b-icon>
							</b-link>
						</b-col>
					</b-row>

					<b-table-simple bordered>
						<b-thead head-variant="light">
							<tr>
								<th>Item</th>
								<th>Manufacturer</th>
								<th>Installed by</th>
								<th>Install date</th>
								<th style="width: 12.5%"></th>
							</tr>
						</b-thead>

						<b-tbody>
							<tr v-for="(component, index) in clock.Equipment" :key="index + 10">
								<td class="align-middle">
									{{ component.Name }}
								</td>

								<td v-if="component.Editable">
									<b-form-input v-model="component.Manufacturer" type="text" />
								</td>
								<td v-else>
									{{ component.Manufacturer }}
								</td>

								<td v-if="component.Editable">
									<b-form-input v-model="component.InstalledBy" type="text" />
								</td>
								<td v-else>
									{{ component.InstalledBy }}
								</td>

								<td v-if="component.Editable">
									<b-form-input v-model="component.InstallDate" type="text" />
								</td>
								<td v-else>
									{{ component.InstallDate }}
								</td>

								<td class="align-middle">
									<b-link class="ml-3 float-right" v-if="!component.Editable" title="Remove this component" @click.prevent="removeFromArray('Equipment', index, true)">
										<b-icon font-scale="1.5" icon="dash-square" variant="danger"></b-icon>
									</b-link>

									<save-or-edit-buttons-row :section="component" @save="updateClock"></save-or-edit-buttons-row>
								</td>
							</tr>
						</b-tbody>
					</b-table-simple>
				</b-form-fieldset>

				<b-form-fieldset>
					<b-row class="mt-3">
						<b-col cols="10">
							<h4>Dials</h4>
						</b-col>
						<b-col cols="2">
							<b-link
								class="float-right"
								v-b-modal.sharedModal
								title="Add a Dial"
								@click.prevent="
									modalContent = 'dial';
									modalTitle = 'Select Dial Type';
								"
							>
								<b-icon font-scale="1.5" icon="plus-square"></b-icon>
							</b-link>
						</b-col>
					</b-row>

					<b-table-simple bordered>
						<b-thead head-variant="light">
							<tr>
								<th>Type</th>
								<th>Diameter (inches)</th>
								<th>Note</th>
								<th style="width: 12.5%"></th>
							</tr>
						</b-thead>

						<b-tbody>
							<tr v-for="(dial, index) in clock.Dials" :key="index + 10">
								<td class="align-middle">
									{{ dial.Name }}
								</td>
								<td v-if="dial.Editable">
									<b-form-input v-model="dial.Diameter" type="text" />
								</td>
								<td v-else>{{ dial.Diameter }}</td>
								<td v-if="dial.Editable">
									<b-form-input v-model="dial.Note" type="text" />
								</td>
								<td v-else>{{ dial.Note }}</td>
								<td class="align-middle">
									<b-link class="ml-3 float-right" v-if="!dial.Editable" title="Remove this Dial" @click.prevent="removeFromArray('Dials', index, true)"> <b-icon font-scale="1.5" icon="dash-square" variant="danger"></b-icon> </b-link
									><save-or-edit-buttons-row :section="dial" @save="updateClock"></save-or-edit-buttons-row>
								</td>
							</tr>
						</b-tbody>
					</b-table-simple>
				</b-form-fieldset>

				<b-form-fieldset>
					<b-row class="mt-3">
						<b-col cols="10">
							<h4>Escapements</h4>
						</b-col>
						<b-col cols="2">
							<b-link
								class="float-right"
								v-b-modal.sharedModal
								title="Add an escapement"
								@click.prevent="
									modalContent = 'escapement';
									modalTitle = 'Select Escapement';
								"
							>
								<b-icon font-scale="1.5" icon="plus-square"></b-icon>
							</b-link>
						</b-col>
					</b-row>

					<b-table-simple bordered>
						<b-thead head-variant="light">
							<tr>
								<th>Item</th>

								<th style="width: 12.5%"></th>
							</tr>
						</b-thead>

						<b-tbody>
							<tr v-for="(escapement, index) in clock.Escapements" :key="index + 10">
								<td class="align-middle">
									{{ escapement.Name }}
								</td>

								<td class="text-right">
									<b-link v-if="!escapement.Editable" title="Remove this Escapement" @click.prevent="removeFromArray('Escapements', index, true)">
										<b-icon font-scale="1.5" icon="dash-square" variant="danger"></b-icon>
									</b-link>
								</td>
							</tr>
						</b-tbody>
					</b-table-simple>
				</b-form-fieldset>
			</b-tab>

			<b-tab lazy title="Files">
				<document-assets :assets="clock.Assets" type="0" :relate="clock.Id" folder="Clock"></document-assets>

				<file-assets :assets="clock.Assets" type="1" :relate="clock.Id" folder="Clock"></file-assets>

				<file-assets :assets="clock.Assets" type="2" :relate="clock.Id" folder="Clock"></file-assets>
			</b-tab>

			<b-tab title="Contacts">
				<b-row class="mt-3">
					<b-col cols="12">
						<b-link
							class="float-right mb-3"
							title="Add a contact"
							v-b-modal.sharedModal
							@click.prevent="
								modalContent = 'add-contact';
								modalTitle = 'Select Contact';
							"
						>
							<b-icon font-scale="1.5" icon="plus-square"></b-icon>
						</b-link>
					</b-col>
				</b-row>

				<b-form-fieldset>
					<b-table-simple bordered>
						<b-thead head-variant="light">
							<tr>
								<th>Name</th>
								<th>Duties</th>
								<th>Note</th>
								<th>Phone</th>
								<th style="width: 15%"></th>
							</tr>
						</b-thead>

						<draggable v-model="clock.Contacts" tag="b-tbody" @end="setContactOrder">
							<tr v-for="(contact, index) in clock.Contacts" :key="index + 10">
								<td class="align-middle">
									<b-link href="#" @click.prevent="editContact(contact.Id, index)">{{ contact.Name }}</b-link>
								</td>

								<td v-if="contact.Editable">
									<v-select multiple v-model="contact.Duties" label="Name" :options="contactDuties"></v-select>
								</td>

								<td v-else>
									<span v-for="(value, index) in contact.Duties" :key="value.Id"> {{ value.Name }}<span v-if="index != contact.Duties.length - 1">,</span> </span>
								</td>
								<td v-if="contact.Editable">
									<b-form-input v-model="contact.Note" type="text" />
								</td>
								<td v-else>{{ contact.Note }}</td>

								<td class="align-middle">
									{{ contact.Telephone ? contact.Telephone + (contact.Mobile ? ' | ' + contact.Mobile : '') : contact.Mobile }}
								</td>

								<td class="align-middle">
									<!--<b-link v-if="!contact.Editable" class="ml-3 float-right" title="Delete this contact" @click.prevent="removeFromArrayAndDelete('Contacts', index, contact.Id, true)">
										<b-icon font-scale="1.5" icon="trash" variant="danger"></b-icon>
									</b-link>-->

									<b-link v-if="!contact.Editable" class="ml-3 float-right" title="Remove this contact" @click.prevent="removeFromArray('Contacts', index, true)">
										<b-icon font-scale="1.5" icon="dash-square" variant="danger"></b-icon>
									</b-link>
									<save-or-edit-buttons-row :section="contact" @save="updateClock"></save-or-edit-buttons-row>
								</td>
							</tr>
						</draggable>
					</b-table-simple>
				</b-form-fieldset>
			</b-tab>

			<b-tab title="Jobs">
				<b-row>
					<b-col md="12">
						<b-table-simple bordered>
							<b-thead head-variant="light">
								<tr>
									<th>Job Number</th>

									<th>Type</th>
									<th>Status</th>
									<th>Due</th>
								</tr>
							</b-thead>
							<b-tbody>
								<tr v-for="job in clock.Jobs" :key="job.Id">
									<td>
										<b-link
											title="Open this job"
											href="#"
											:to="{
												name: 'jobupdate',
												params: { id: job.Id }
											}"
											>{{ job.Id }}</b-link
										>
									</td>

									<td>{{ jobTypeName(job.Type) }}</td>
									<td>{{ job.Status.Name }}</td>
									<td>{{ formatDate(job.Due) }}</td>
								</tr>
							</b-tbody>
						</b-table-simple>
					</b-col>
				</b-row>
			</b-tab>

			<b-tab title="Log">
				<b-row class="mt-3">
					<b-col cols="10" class="mt-3 mb-3">
						<h4>Notes</h4>
					</b-col>

					<b-col cols="2">
						<b-link
							class="float-right mb-3"
							title="Add a note"
							v-b-modal.sharedModal
							@click.prevent="
								modalContent = 'note';
								modalTitle = 'Add note';
							"
						>
							<b-icon font-scale="1.5" icon="plus-square"></b-icon>
						</b-link>
					</b-col>
				</b-row>

				<b-form-fieldset>
					<b-table-simple bordered>
						<b-thead head-variant="light">
							<tr>
								<th>Date</th>
								<th>Person</th>
								<th>Change</th>
							</tr>
						</b-thead>

						<b-tbody>
							<tr v-for="(log, index) in logs" :key="index + 10">
								<td>{{ formatDate(log.Added) }}</td>

								<td>{{ log.FullName }}</td>
								<td>{{ log.Note }}</td>
							</tr>
						</b-tbody>
					</b-table-simple>
				</b-form-fieldset>
			</b-tab>
		</b-tabs>

		<b-modal id="sharedModal" ref="sharedModal" :title="modalTitle" hide-footer no-close-on-backdrop>
			<set-or-create-customer v-if="modalContent == 'customer'" @set="setCustomer" />

			<set-component v-if="modalContent == 'component'" @add="addEquipment" />

			<set-dial v-if="modalContent == 'dial'" @add="addDial" />

			<set-escapement v-if="modalContent == 'escapement'" @add="addEscapement" />

			<add-contact v-if="modalContent == 'add-contact'" @addContact="addContact" />

			<edit-contact v-if="modalContent == 'edit-contact'" @updateContact="updateContact" :editing="editing" />

			<add-job v-if="modalContent == 'job'" @addJob="addJob" :clock="clock" />

			<add-note v-if="modalContent == 'note'" @addNote="addNote" entityType="Clock" :entityId="clock.Id" />
		</b-modal>

		<confirm ref="confirm"></confirm>
	</b-form>
</template>

<script>
import ClockService from '@/api-services/clock.service';
import ClockTypeService from '@/api-services/clocktype.service';
import LogService from '@/api-services/log.service';

import AddContact from '@/components/partials/add-contact-to-parent';
import AddJob from '@/components/partials/add-job';
import EditContact from '@/components/partials/edit-contact';
import FileAssets from '@/components/partials/file-assets';
import DocumentAssets from '@/components/partials/document-assets';

import SaveOrEditButtons from '@/components/partials/save-or-edit-buttons';
import SaveOrEditButtonsRow from '@/components/partials/save-or-edit-buttons-row';
import SetOrCreateCustomer from '@/components/partials/set-customer';
import SetComponent from '@/components/partials/set-component';
import SetDial from '@/components/partials/set-dial';
import SetEscapement from '@/components/partials/set-escapement';
import Confirm from '@/components/partials/confirm';
import AddNote from '@/components/partials/add-note';

import Draggable from 'vuedraggable';

import VSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import { dateFuncs } from '@/globs.js';

export default {
	name: 'ClockForm',

	// things we have inherited from our parent, we are directly edting this with our methods
	props: ['clock', 'dirty', 'editable'],

	components: {
		AddContact,
		AddJob,
		EditContact,
		VSelect,
		Draggable,
		FileAssets,
		DocumentAssets,
		SaveOrEditButtons,
		SaveOrEditButtonsRow,
		SetOrCreateCustomer,
		SetComponent,
		SetDial,
		SetEscapement,
		Confirm,
		AddNote
	},

	// data we bind to, components need a function wrapping this all up, to keep instances seperate
	data: function () {
		return {
			clockTypes: [],
			equipment: [],
			dialTypes: [],
			quarterChimes: [],
			customers: [],
			escapements: [],

			editing: {
				id: null,
				index: null
			},

			deleting: {
				id: null,
				index: null
			},

			modalContent: null,
			modalTitle: 'Select',

			contactDuties: [
				{ Id: 1, Name: 'Primary Contact' },
				{ Id: 2, Name: 'Key holder' },
				{ Id: 3, Name: 'Emergency' },
				{ Id: 4, Name: 'Invoice' },
				{ Id: 5, Name: 'Secondary' },
				{ Id: 6, Name: 'Owner' }
			],

			jobTypes: [
				{ Value: 0, DisplayName: 'Enquiry' },
				{ Value: 1, DisplayName: 'Problem' },
				{ Value: 2, DisplayName: 'Service' },
				{ Value: 3, DisplayName: 'Job' }
			],

			logs: []
		};
	},

	computed: {
		customerName() {
			if (this.clock.Customer) return this.clock.Customer.Name;
		},

		quarterChimeName() {
			return this.quarterChimes
				.filter((q) => q.Value == this.clock.QuarterChime)
				.map(function (obj) {
					return obj.DisplayName;
				})
				.join();
		},

		clockTypeName() {
			return this.clockTypes
				.filter((q) => q.Id == this.clock.ClockTypeId)
				.map(function (obj) {
					return obj.Name;
				})
				.join();
		},

		threeWordsLink() {
			return 'https://what3words.com/' + this.clock.Address.What3Words;
		}
	},

	mounted() {
		this.fetchClockTypes();
		this.fetchClockChimes();
		this.fetchLogs();

		// if we came here from the create page, then show things as editable
		if (this.$route.query.creating) {
			this.editable.address = true;
			this.editable.notes = true;
			this.editable.details = true;
		}
	},

	// things we do to data
	methods: {
		someThingChanged() {
			this.$emit('update:dirty', true);
		},

		fallback(str, alt) {
			return str ? str : alt;
		},

		withBr(str) {
			return !str || 0 === str.length ? '' : str + '</br>';
		},

		jobTypeName(id) {
			return this.jobTypes
				.filter((q) => q.Value == id)
				.map(function (obj) {
					return obj.DisplayName;
				})
				.join();
		},

		editSection(section) {
			this.editable[section] = true;
		},

		saveSection(section) {
			this.updateClock(section);
		},

		removeFromArray(section, index, hold) {
			if (hold) {
				this.$refs.confirm.open('Confirm action', 'Are you sure you want to remove this item from ' + section).then((confirm) => {
					if (confirm) {
						this.removeFromArray(section, index);
					}
				});
			} else {
				this.$delete(this.clock[section], index);
				this.updateClock();
			}
		},

		removeFromArrayAndDelete(section, index, id, hold) {
			if (hold) {
				this.$refs.confirm.open('Confirm action', 'Are you sure you want to delete this contact completely?').then((confirm) => {
					if (confirm) {
						this.removeFromArrayAndDelete(section, index, id);
					}
				});
			} else {
				ClockService.deleteContact(this.clock.Id, id)
					.then(() => {
						this.$delete(this.customer[section], index);
						this.updateCustomer();
					})
					.catch((error) => {
						let modal_options = {
							text: 'light',
							background: 'danger'
						};

						this.$refs.confirm.open('Error', "Can't delete because the contact is linked to another clock or customer, removing instead.", true, modal_options);
					});
			}
		},

		addEquipment(component) {
			this.clock.Equipment.push({
				Id: component.Id,
				Name: component.Name,
				Manufacturer: '',
				ManufactureDate: ''
			});

			this.$nextTick(() => {
				this.updateClock();
				this.modalContent = null;
				this.$refs.sharedModal.hide();
			});
		},

		addDial(dial) {
			this.clock.Dials.push({
				Id: dial.Id,
				Name: dial.Name,
				Diameter: '',
				Note: ''
			});

			this.$nextTick(() => {
				this.updateClock();
				this.modalContent = null;
				this.$refs.sharedModal.hide();
			});
		},

		addEscapement(escapement) {
			this.clock.Escapements.push({
				Id: escapement.Id,
				Name: escapement.Name
			});

			this.$nextTick(() => {
				this.updateClock();
				this.modalContent = null;
				this.$refs.sharedModal.hide();
			});
		},

		addJob(newJob) {
			this.modalContent = null;
			this.$refs.sharedModal.hide();

			this.$nextTick(() => {
				this.$router.push({
					name: 'jobupdate',
					params: { id: newJob.Id }
				});
			});
		},

		fetchClockTypes() {
			ClockTypeService.getAll()
				.then((response) => {
					this.clockTypes = response.data;
				})
				.catch((error) => {
					console.log('not authorized');
				});
		},

		fetchClockChimes() {
			ClockService.getEnum('chime')
				.then((response) => {
					this.quarterChimes = response.data;
				})
				.catch((error) => {
					console.log('not authorized');
				});
		},

		fetchLogs() {
			LogService.get('Clock', this.$router.currentRoute.params.id).then((response) => {
				this.logs = response.data;
			});
		},

		addNote() {
			this.fetchLogs();
			this.$nextTick(() => {
				this.modalContent = null;
				this.$refs.sharedModal.hide();
			});
		},

		setCustomer(customer) {
			this.clock.CustomerId = customer.Id;
			this.clock.Customer = customer;

			this.$nextTick(() => {
				this.modalContent = null;
				this.$refs.sharedModal.hide();
			});
		},

		addContact(contactFromForm) {
			var valObj = this.clock.Contacts.filter(function (elem) {
				// is this contact already in out list?
				if (elem.Id === contactFromForm.Id) return elem;
			});

			if (valObj.length > 0) {
				let modal_options = {
					text: 'light',
					background: 'danger'
				};

				this.$refs.confirm.open('Error', 'Contact already assigned', true, modal_options);
			} else {
				// we need to query duties, so make sure it is set for new people.
				if (contactFromForm.Duties === undefined)
					// this wont be reactive unless we set it
					this.$set(contactFromForm, 'Duties', []);

				this.clock.Contacts.push(contactFromForm);
			}

			// Hide the modal manually
			this.$nextTick(() => {
				this.updateClock();
				this.modalContent = null;
				this.$refs.sharedModal.hide();
			});
		},

		editContact(contactId, index) {
			this.editing.id = contactId;
			this.editing.index = index;

			this.$nextTick(() => {
				this.modalContent = 'edit-contact';
				this.modalTitle = 'Edit Contact';
				this.$refs.sharedModal.show();
			});
		},

		updateContact(contactFromForm) {
			// our newly updated contact - we need to set the basics to visually update

			let foundContact = this.clock.Contacts.find((contact) => contact.Id === this.editing.id);

			foundContact.Name = contactFromForm.Name;
			foundContact.Email = contactFromForm.Email;
			foundContact.Telephone = contactFromForm.Telephone;
			foundContact.Mobile = contactFromForm.Mobile;

			this.editing = {
				id: null,
				index: null
			};

			this.$nextTick(() => {
				this.modalContent = null;
				this.$refs.sharedModal.hide();
			});
		},

		setContactOrder() {
			this.clock.Contacts.forEach((contact, i) => {
				contact.Order = i;
			});
		},

		formatDate(date) {
			return dateFuncs.humanDateFormat(date);
		},

		deleteClock() {
			this.$emit('delete');
		},

		updateClock(section) {
			this.$emit('update', section);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/clock/clock-form.vue